import { MessageBar, MessageBarType } from "@fluentui/react";
import Form from "antd/lib/form/Form";
import { Formik } from "formik";
import React, { createContext, useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";
import SettingStore from "../store/settingstore";
import { toJS } from "mobx";
import FormItem from "antd/lib/form/FormItem";
import { Button, Divider, Input, notification } from "antd";
import moment from "moment";
const settingStorectx = createContext(SettingStore);
export const NaocFlashProductionSettings = observer(() => {
  const settingStore = useContext(settingStorectx);
  useEffect(() => {
    async function loadSettings() {
      try {
        await settingStore.loadFlashSettings();
      } catch (error) {
        notification.error({
          message: "SPARS Feedback",
          description: `download failed,${error.message}`,
        });
      }
    }
    loadSettings();
  }, []);

  return (
    <div className="ms-Grid" dir="ltr" style={{ padding: "5px" }}>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm9">
          <SubPageHeaderTitle title="NAOC Flash Production Input Deck Configurations" />
          <div>Excel Worksheet Cell Address</div>
        </div>
        <div className="ms-Grid-col ms-sm3" style={{ textAlign: "right" }}>
          <Button
            type="primary"
            disabled={!settingStore.isflashSettingsModified}
            loading={settingStore.isSaving}
            onClick={async () => {
              try {
                const res = await settingStore.saveFlashSettings();
                if (res.success) {
                  settingStore.isflashSettingsModified = false;
                  settingStore.flashSettings = res.setting;
                  settingStore.isSaving = false;
                  notification.success({
                    message: "SPARS Feedback",
                    description:
                      "NAOC Input deck settings modification saved successfully",
                  });
                }
              } catch (error) {
                notification.error({
                  message: "SPARS Feedback",
                  description: `download failed,${error.message}`,
                });
              } finally {
                settingStore.isSaving = false;
              }
            }}
          >
            Save Modifiations
          </Button>
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <MessageBar messageBarType={MessageBarType.warning}>
            Ensure you map correctly , the production field entries with
            respective current worksheet cell addresses.Any mapping error would
            cause values extractions failure thereby preventing the template to
            preview and upload
          </MessageBar>
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <Formik
            initialValues={toJS(settingStore.flashSettings)}
            enableReinitialize={true}
          >
            {({ values }) => (
              <Form
                layout="vertical"
                labelAlign="left"
                style={{ background: "#fff", padding: "10px" }}
              >
                <div className="ms-Grid" dir="ltr">
                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm4">
                      <SubPageHeaderTitle
                        title="OIL PRODUCTION (bopd)"
                        color="red"
                      />
                      <FormItem
                        label="Land Area Metered/Adjusted"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="landAreaOil"
                          value={values?.landAreaOil}
                          onChange={({ target }) => {
                            settingStore.flashSettings.landAreaOil =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                      <FormItem
                        label="Swamp Area Metered/Adjusted"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="swampAreaOil"
                          value={values?.swampAreaOil}
                          onChange={({ target }) => {
                            settingStore.flashSettings.swampAreaOil =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                      <FormItem
                        label="BENIBOYE Daily Metered"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="beniboyeOilDailyMetered"
                          value={values?.beniboyeOilDailyMetered}
                          onChange={({ target }) => {
                            settingStore.flashSettings.beniboyeOilDailyMetered =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                      <FormItem
                        label="Total Metered/Adjusted Prod"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="totalOilMeteredProd"
                          value={values?.totalOilMeteredProd}
                          onChange={({ target }) => {
                            settingStore.flashSettings.totalOilMeteredProd =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                      <FormItem
                        label="Total NAOC JV Oil Produced/Evacuated"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="totalOilProduced"
                          value={values?.totalOilProduced}
                          onChange={({ target }) => {
                            settingStore.flashSettings.totalOilProduced =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                    </div>
                    <div className="ms-Grid-col ms-sm4">
                      <SubPageHeaderTitle
                        title="GAS PRODUCTION (mscf/d)"
                        color="green"
                      />
                      <FormItem
                        label="Land Area Gas Produced"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="landAreaGas"
                          value={values?.landAreaGas}
                          onChange={({ target }) => {
                            settingStore.flashSettings.landAreaGas =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                      <FormItem
                        label="Swamp Area Gas Produced"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="swampAreaGas"
                          value={values?.swampAreaGas}
                          onChange={({ target }) => {
                            settingStore.flashSettings.swampAreaGas =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>

                      <Divider
                        style={{ marginTop: "2px", color: "#48BB78" }}
                        orientation="left"
                        dashed
                      ></Divider>
                      <SubPageHeaderTitle
                        title="  GAS UTILIZATION (mscf/d)"
                        color="#22543D"
                      />
                      <FormItem
                        label="Total Gas Flared"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="totalGasFlared"
                          value={values?.totalGasFlared}
                          onChange={({ target }) => {
                            settingStore.flashSettings.totalGasFlared =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                      <FormItem
                        label="Total Gas Internally Utilized"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="totalGasInternallyUtilized"
                          value={values?.totalGasInternallyUtilized}
                          onChange={({ target }) => {
                            settingStore.flashSettings.totalGasInternallyUtilized =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                      <FormItem
                        label="Gas Utilized for NGL"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="gasInternallyUtilizedforNGL"
                          value={values?.gasInternallyUtilizedforNGL}
                          onChange={({ target }) => {
                            settingStore.flashSettings.gasInternallyUtilizedforNGL =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                    </div>
                    <div className="ms-Grid-col ms-sm4">
                      <SubPageHeaderTitle
                        title=" GAS EVACUATION (mscf/d)"
                        color="#48BB78"
                      />
                      <FormItem
                        label="Daily FuelGas To EPCL."
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="dailyFuelGasToEPCL"
                          value={values?.dailyFuelGasToEPCL}
                          onChange={({ target }) => {
                            settingStore.flashSettings.dailyFuelGasToEPCL =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                      <FormItem
                        label="Daily Gas Delivery to RS IPP"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="dailyGasDeliveryToRSIPP"
                          value={values?.dailyGasDeliveryToRSIPP}
                          onChange={({ target }) => {
                            settingStore.flashSettings.dailyGasDeliveryToRSIPP =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                      <FormItem
                        label="Daily Gas Delivery to BONNY"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="dailyGasDeliveryToBonny"
                          value={values?.dailyGasDeliveryToBonny}
                          onChange={({ target }) => {
                            settingStore.flashSettings.dailyGasDeliveryToBonny =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                      <FormItem
                        label="Daily Gas Delivery to JV IPP"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="dailyGasJVIPP"
                          value={values?.dailyGasJVIPP}
                          onChange={({ target }) => {
                            settingStore.flashSettings.dailyGasJVIPP =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                      <FormItem
                        label="Daily Gas To EPCL FERT PLT"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="dailyGasEPCLFertPLT"
                          value={values?.dailyGasEPCLFertPLT}
                          onChange={({ target }) => {
                            settingStore.flashSettings.dailyGasEPCLFertPLT =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                    </div>
                  </div>

                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm4">
                      <SubPageHeaderTitle
                        title="GAS INJECTION / LIFT (mscf/d)"
                        color="#68D391"
                      />
                      <FormItem
                        label="OB/OB G/Plant Gas Inj./Lift"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="obGpGasInj"
                          value={values?.obGpGasInj}
                          onChange={({ target }) => {
                            settingStore.flashSettings.obGpGasInj =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                      <FormItem
                        label="Kwale G/Plant Gas Inj./Lift"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="kwaleGpGasInj"
                          value={values?.kwaleGpGasInj}
                          onChange={({ target }) => {
                            settingStore.flashSettings.kwaleGpGasInj =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                      <FormItem
                        label="Akri Gas To Oguta Plant"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="akriGasInjToOGutaPlant"
                          value={values?.akriGasInjToOGutaPlant}
                          onChange={({ target }) => {
                            settingStore.flashSettings.akriGasInjToOGutaPlant =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                      <FormItem
                        label="Gas Inj.Into Akri 2 at Oguta"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="akriGasToOGutaPlant"
                          value={values?.akriGasToOGutaPlant}
                          onChange={({ target }) => {
                            settingStore.flashSettings.akriGasToOGutaPlant =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                    </div>

                    <div className="ms-Grid-col ms-sm4">
                      {" "}
                      <SubPageHeaderTitle
                        title="GAS METERS (mscf/d)"
                        color="#2F855A"
                      />
                      <FormItem
                        label="Total Gas Rec. at OB/OB G/Plant"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="totalGasRecOBGp"
                          value={values?.totalGasRecOBGp}
                          onChange={({ target }) => {
                            settingStore.flashSettings.totalGasRecOBGp =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                      <FormItem
                        label="Total Gas Rec. at Kwale G/Plant"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="totalGasRecKwaleGp"
                          value={values?.totalGasRecKwaleGp}
                          onChange={({ target }) => {
                            settingStore.flashSettings.totalGasRecKwaleGp =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                    </div>
                    <div className="ms-Grid-col ms-sm4">
                      {" "}
                      <SubPageHeaderTitle title="NGL (bopd)" color="#D69E2E" />
                      <FormItem
                        label="NGL Produced"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="nglProduced"
                          value={values?.nglProduced}
                          onChange={({ target }) => {
                            settingStore.flashSettings.nglProduced =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                      <FormItem
                        label="NGL Delivered"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="nglDelivered"
                          value={values?.nglDelivered}
                          onChange={({ target }) => {
                            settingStore.flashSettings.nglDelivered =
                              target.value;
                            settingStore.isflashSettingsModified = true;
                          }}
                        />
                      </FormItem>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>

        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm3">
            <FormItem
              label="Production Refer Date"
              labelAlign="left"
              className="add-border"
            >
              <Input
                style={{ width: "80px" }}
                name="productionDate"
                value={settingStore.flashSettings?.productionDate}
                onChange={({ target }) => {
                  settingStore.flashSettings.productionDate = target.value;
                }}
              />
            </FormItem>
          </div>
          <div className="ms-Grid-col ms-sm9">
            <MessageBar messageBarType={MessageBarType.info}>
              last modified by {settingStore?.flashSettings?.uploadedBy} on{" "}
              {moment(settingStore?.flashSettings?.uploadedOn).format(
                "MMMM Do YYYY, h:mm:ss a"
              )}
            </MessageBar>
          </div>
        </div>
      </div>
    </div>
  );
});

